import { create } from "zustand"; // 👈 use named import

const useAuthStore = create((set) => ({
    user: null,                      // User object or null
    setUser: (user) => set({ user }), // Set user globally
    clearUser: () => set({ user: null }), // Clear user globally
}));

export default useAuthStore;